const request = {
    invalid_input: 'Girdi geçersiz. {{details}}',
    general: 'İstek hatası oluştu.',
    /** UNTRANSLATED */
    range_not_satisfiable: 'Range not satisfiable.',
    /** UNTRANSLATED */
    too_many_requests: 'Too many requests.',
};
export default Object.freeze(request);
